
export default {
  name: 'CollectionPageStructuredData',
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          hid: 'collectionpage-structured-data',
          innerHTML: JSON.stringify(this.structuredData),
          type: 'application/ld+json',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return this.url || this.$config.url + this.$route.path
    },
    structuredData() {
      const data = {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: this.name,
        url: this.pageUrl,
        isPartOf: {
          '@type': 'WebSite',
          name: 'AGM Vision',
          url: this.$config.url,
        },
      }
      if (this.description) {
        data.description = this.description
      }
      if (this.items.length) {
        data.mainEntity = {
          '@type': 'ItemList',
          numberOfItems: this.items.length,
          itemListElement: this.items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            url: item.url,
          })),
        }
      }
      return data
    },
  },
}
